import BaseClient from '../base-client';
import { formatAttachment } from './model';

export default class AttachmentClient extends BaseClient {
  constructor(options = {}) {
    super('', {
      format: formatAttachment,
      ...options,
    });
  }

  async upload(file, ticketId, userId, refNum, server, rep, pfirmasId) {
    try {
      const formData = new FormData();
      formData.append('objectHandle', ticketId);
      formData.append('userid', userId);
      formData.append('refNum', refNum);
      formData.append('pfirmasId', pfirmasId);
      formData.append('file', file);

      const response = await this.request('post', `ticket/${ticketId}/upload`)(formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log('upload response', response);

      return { ok: true };
    } catch (ex) {
      throw this.handleError(ex);
    }
  }

  async uploadApp(file, ticketId, userId, refNum, server, rep, pfirmasId, accessKey, token, path) {
    try {
      const formData = new FormData();
      formData.append('objectHandle', ticketId);
      formData.append('userid', userId);
      formData.append('refNum', refNum);
      formData.append('pfirmasId', pfirmasId);

      let fetchPath = '';
      if (path.includes('/servicioandaluzdesalud/mics')) {
        fetchPath = '/servicioandaluzdesalud/mics';
      } else if (path.includes('/mics')) {
        fetchPath = '/mics';
      }

      if (file instanceof Uint8Array) {
        const filename = file.name ?? (Math.random() + 1)
          .toString(36)
          .replace(/(\.|,)/g, '')
          .concat('.pdf');
        // const fObject = new File(file, filename);
        const fObject = new Blob([file], { type: 'pdf' });
        formData.append('file', fObject, filename);
      } else {
        formData.append('file', file);
      }

      const response = await fetch(`${fetchPath}/proxy-rest/ticket/${ticketId}/upload`, {
        method: 'POST',
        body: formData,
        headers: {
          'x-accesskey': accessKey,
          'x-jwt-token': token,
        },
      });
      console.log('upload response', response);

      return response;
    } catch (ex) {
      throw this.handleError(ex);
    }
  }
}
